class AdminAvatar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var dims = { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight };
		var src = require("owls/default-owl-10.png");

		return (
			<img src={ src } alt="adminAvatar" className="adminAvatar" style={ dims } />
		)
	}
};

AdminAvatar.propTypes = StrictPropTypes({
	// We don't actually use user but we may at some point
	// so we should require it to be passed
	admin: PropTypes.object.isRequired,

	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number
});

module.exports = AdminAvatar;


// WEBPACK FOOTER //
// ./modules/components/avatars/AdminAvatar.js